import { jsonParseSafe } from "@gr-common/head/json";

interface OnexData {
  onexes?: (Onex | undefined)[];
}

interface Onex {
  n: string;
  v: string;
}

/**
 *
 */
export function parseIntermediateFragment(jsonText: string): void {
  const data = jsonParseSafe<OnexData>(jsonText);
  if (!data?.onexes || !Array.isArray(data.onexes)) return;

  const onexes = Object.fromEntries(
    data.onexes.map((onex) => (onex ? ([onex.n, onex.v] as const) : undefined)).filter(Boolean),
  );

  window.__onex__ = onexes;
  otto.onex.assignments.set(onexes);
}

export function readOnexData(): void {
  /*                                        */
  if (window.__onex__) return;

  const fragment = document.getElementById("__onex-assignments") as HTMLScriptElement | null;
  if (!fragment?.textContent) return;
  parseIntermediateFragment(fragment.textContent);
}

export async function fetchOnexData(): Promise<void> {
  /*                                        */
  if (window.__onex__) return;

  const response = await fetch(new URL("/onex/assignments/", window.location.href));
  if (!response.ok) return;
  const text = await response.text();
  parseIntermediateFragment(text);
}
